import React from "react";
import { BgImage as _BgImage, IBgImageProps } from "gbimage-bridge";

type BgImageProps = React.HtmlHTMLAttributes<HTMLDivElement> & IBgImageProps;

export default function BgImage(props: BgImageProps) {
  return <_BgImage {...props} />;
}
